module.exports = __webpack_public_path__ + "img/bannerDesktopOld.f3fca1dc.jpg";